import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { faCheck } from '@fortawesome/free-solid-svg-icons';

export default function SubItem({category,parent,open,selected,setSelected,dispatch}) {
  
  return (
    <div
      onClick={() => {
        if (selected.includes(category.slug)) {
          dispatch(
            setSelected(selected.filter((item) => item != category.slug))
          );
        } else {
          dispatch(
            setSelected([
              ...selected.filter((x) => x != parent.slug),
              category.slug,
            ])
          );
        }
      }}
      className={"category-sub-item "}
      style={{ display: open ? "flex" : "none" }}
    >
      <span
        className={
          "check-box " + (selected.includes(category.slug) ? "checked" : "")
        }
      >
        <span>
          <FontAwesomeIcon icon={faCheck} />
        </span>
      </span>
      <div className="name">
        <span>
          {category.name}
        </span>
        <span style={{ fontSize: 12 }}>
          
        </span>
      </div>
    </div>
  );
}
